import { render, staticRenderFns } from "./GiveawayView.vue?vue&type=template&id=e855e9ba&scoped=true"
import script from "./GiveawayView.vue?vue&type=script&lang=js"
export * from "./GiveawayView.vue?vue&type=script&lang=js"
import style0 from "./GiveawayView.vue?vue&type=style&index=0&id=e855e9ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e855e9ba",
  null
  
)

export default component.exports